import React from 'react';
import { useEFM } from '@/components/Ajax';

export default function useGetSurveySettings({ surveyKey, wait, onSuccess = () => {} }) {
	return useEFM('/survey/ajax/get-survey', { surveyKey }, wait, false, false, {
		onSuccess,
	});
}
